module.exports = __webpack_public_path__ + "img/calendar-white.23e9e66b.svg";